export default function TextField({ formId, textField, answers, setAnswers }) {
    return (
        <div className={"mb-3"}>
            <label htmlFor={formId + textField.id} className={"form-label"}>{textField.name}:</label>
            <textarea form={formId} required={textField.required} id={formId + textField.id} className={"form-control"} value={answers.textFields.find(value => value.id === textField.id).value} onChange={evt => {
                setAnswers(prev => {
                    const newState = { ...prev };
                    const newTextFields = [
                        ...newState.textFields
                    ];
                    newState.textFields = newTextFields;
                    newTextFields.find(value => value.id === textField.id).value = evt.target.value;
                    return newState;
                });
            }} />
        </div>
    );
}
